// extracted by mini-css-extract-plugin
export default {"form-divider":"FormDivider__form-divider___va_Cw"};